import util from '@bmp-vue/core/api/util'

const controller = 'Cedentes'
export default Object.assign({}, util.GetCrud(controller, ['get', 'getall', 'post', 'put', 'persist']), {
  GetByConta: function (dto) {
    return util.Axios.Get(`${controller}/GetByConta`, dto)
  },
  Combo: function (mostrarInativos) {
    return util.Axios.Get(`${controller}/Combo/${mostrarInativos}`)
  },
  Reprocessar: function (id) {
    return util.Axios.Put(`${controller}/Reprocessar`, id)
  },
  GetCedente: function (id) {
    return util.Axios.Get(controller, id)
  }
})
